import { createClient } from "@supabase/supabase-js";
import { getCsrfHeaders, clearCsrfToken } from "./utility/security/csrfUtils";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Create a single Supabase client
const baseClient = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    flowType: "pkce",
    onAuthStateChange: (event, session) => {
      if (event === "SIGNED_OUT") {
        clearCsrfToken();
      }
    },
  },
});

const attachCsrfHeaders = (builder) => {
  const csrfHeaders = getCsrfHeaders();
  if (typeof builder?.setHeader === "function") {
    Object.entries(csrfHeaders).forEach(([key, value]) => {
      builder.setHeader(key, value);
    });
    return builder;
  }
  if (builder?.headers && typeof builder.headers.set === "function") {
    Object.entries(csrfHeaders).forEach(([key, value]) => {
      builder.headers.set(key, value);
    });
    return builder;
  }
  if (builder?.headers && typeof builder.headers === "object") {
    Object.assign(builder.headers, csrfHeaders);
  }
  return builder;
};

// Export the base client for edge functions (no CSRF headers)
export const supabaseWithoutCSRF = baseClient;

// Create a wrapper that adds CSRF headers for regular database calls
export const supabase = {
  ...baseClient,
  from: (table) => attachCsrfHeaders(baseClient.from(table)),
  rpc: (func, params) => attachCsrfHeaders(baseClient.rpc(func, params)),
  // Keep all other methods from the base client
  functions: baseClient.functions,
  auth: baseClient.auth,
  storage: baseClient.storage,
  channel: baseClient.channel,
  removeChannel: baseClient.removeChannel,
  removeAllChannels: baseClient.removeAllChannels,
  getChannels: baseClient.getChannels,
};
